<template>
  <div class="mibo-video-player">
    <video
      ref="video"
      class="mibo-video-player__el"
      controls
      playsinline
      :poster="poster || undefined"
    />
    <div v-if="errorMsg" class="mibo-video-player__error">{{ errorMsg }}</div>
  </div>
</template>

<script>
import Hls from 'hls.js'

export default {
  name: 'MiboVideoPlayer',
  props: {
    src: {
      type: String,
      default: ''
    },
    poster: {
      type: String,
      default: ''
    },
    autoplay: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      hls: null,
      errorMsg: ''
    }
  },
  watch: {
    src: {
      immediate: true,
      handler (val) {
        this.$nextTick(() => this.loadSource(val))
      }
    }
  },
  beforeDestroy () {
    this.destroyPlayer()
  },
  methods: {
    isHls (url) {
      return /\.m3u8(\?|$)/i.test(url || '')
    },
    destroyPlayer () {
      if (this.hls) {
        this.hls.destroy()
        this.hls = null
      }
      const video = this.$refs.video
      if (video) {
        video.removeAttribute('src')
        video.load()
      }
    },
    loadSource (url) {
      this.errorMsg = ''
      this.destroyPlayer()
      const video = this.$refs.video
      if (!video || !url) {
        return
      }
      if (this.isHls(url)) {
        if (Hls.isSupported()) {
          this.hls = new Hls({
            enableWorker: true,
            lowLatencyMode: true,
            maxLiveSyncPlaybackRate: 1.25,
            backBufferLength: 0
          })
          this.hls.loadSource(url)
          this.hls.attachMedia(video)
          this.hls.on(Hls.Events.ERROR, (_, data) => {
            if (data && data.fatal) {
              const net = data.type === Hls.ErrorTypes.NETWORK_ERROR
              this.errorMsg = net
                ? '视频流网络加载失败（若为域名地址，请检查宝塔是否对 /live/ 做了 cookieCheck）'
                : '视频流加载失败，设备可能离线或暂无画面'
            }
          })
          if (this.autoplay) {
            video.play().catch(() => {})
          }
          return
        }
        if (video.canPlayType('application/vnd.apple.mpegurl')) {
          video.src = url
          if (this.autoplay) {
            video.play().catch(() => {})
          }
          return
        }
        this.errorMsg = '当前浏览器不支持 HLS 播放'
        return
      }
      video.src = url
      if (this.autoplay) {
        video.play().catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.mibo-video-player {
  width: 100%;
  background: #000;
  border-radius: 4px;
  overflow: hidden;
}
.mibo-video-player__el {
  width: 100%;
  max-height: 480px;
  display: block;
  background: #000;
}
.mibo-video-player__error {
  color: #fff;
  padding: 12px;
  text-align: center;
  background: rgba(0, 0, 0, 0.75);
}
</style>
